const BOOKED_OFFERS_IDS = 'booked_offers_ids';

export function getBookingSuccessNotificationShownStatus(offerId: number): boolean {
  if (!sessionStorage) {
    return false;
  }

  const bookedOffersIds = sessionStorage.getItem(BOOKED_OFFERS_IDS);

  let parsedBookedOffersIds;

  if (bookedOffersIds) {
    parsedBookedOffersIds = JSON.parse(bookedOffersIds);
  }

  return Boolean(
    parsedBookedOffersIds && Array.isArray(parsedBookedOffersIds) && parsedBookedOffersIds.includes(offerId),
  );
}

export function saveBookedOfferIdToLocalStorage(offerId: number) {
  if (!sessionStorage) {
    return;
  }

  const bookedOffersIds = sessionStorage.getItem(BOOKED_OFFERS_IDS);
  let newBookedOffersIds = [offerId];
  let parsedBookedOffersIds;

  if (bookedOffersIds) {
    parsedBookedOffersIds = JSON.parse(bookedOffersIds);

    if (parsedBookedOffersIds && Array.isArray(parsedBookedOffersIds)) {
      newBookedOffersIds = newBookedOffersIds.concat(parsedBookedOffersIds);
    }
  }

  sessionStorage.setItem(BOOKED_OFFERS_IDS, JSON.stringify(newBookedOffersIds));
}
